import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSpeedHigh: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="speed-high, limit, speedometer, level"><path d="M6.88505 19.7084C4.39266 18.0512 2.75 15.2174 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1087 2.75 21.25 6.89137 21.25 12C21.25 15.2174 19.6074 18.0512 17.115 19.7084" stroke="currentColor" strokeWidth="1.5"/><path d="M10.468 14.2846C9.75795 13.4385 9.86832 12.177 10.7145 11.467C11.5606 10.757 12.8221 10.8673 13.5321 11.7135C15.1391 13.6286 15.8568 17.5953 15.8568 17.5953C15.8568 17.5953 12.0749 16.1998 10.468 14.2846Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSpeedHigh;
